import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Icon, Card, Popconfirm, Popover, message } from 'antd';
import SERVER_URL from '../Global';

export class UserCardDetail extends Component {
    static displayName = UserCardDetail.name;

    constructor(props) {
        super(props);

        this.state = {
            user: this.props.user,
            token:this.props.token
        };

        this.deleteHr = this.deleteHr.bind(this);
        this.restore = this.restore.bind(this);
        this.disable = this.disable.bind(this);
        this.saveUser = this.saveUser.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.user !== prevProps.user) {
            this.setState({ user: this.props.user });
        }
    }

    deleteHr() {
        this.props.delete();
    }

    restore() {
        //reset della password via mail
        fetch(
            `${SERVER_URL + "api/users/resetPassword"}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.token}`
            },
            body: JSON.stringify({
                'username': this.state.user.username
            })
        }).then(response => response.json())
            .then(res => {
                if (res.ok) {
                    message.success('The User will shortly receive an email with a link to restore the password');
                } else {
                    this.setState({ errorChange: true })
                }
            })
    }

    saveUser() {
        fetch(`${SERVER_URL + 'api/users'}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.token}`,
            },
            body: JSON.stringify({
                'FirstName': this.state.user.firstName,
                'LastName': this.state.user.lastName,
                'Username': this.state.user.username,
                'Email': this.state.user.email,
                'Password': this.state.user.password,
                'IsEnabled': this.state.user.isEnabled,
                'userId': this.state.user.userId,
                'UserRoleId': 1,
            })
        })
    }

    disable() {
        if (this.state.user.isEnabled) {
            let user = this.state.user
            user.isEnabled = false;
            this.setState({ user: user },
                this.props.recallDisabled)
        } else {
            let user = this.state.user
            user.isEnabled = true;
            this.setState({ user: user },
                this.props.recallDisabled)
        }
        this.saveUser()
    }

    render() {

        let enabled = this.state.user.isEnabled ? "Enabled" : "Disabled"
        let deleteAction = <Popconfirm title="Are you sure to delete this user?" okText="Yes" cancelText="No" onConfirm={this.deleteHr} ><Popover content="Delete"><Icon type="close" className="blueIcon" /></Popover></Popconfirm>
        let restoreAction = <Popconfirm title="Do you want to reset this user's password?" okText="Yes" cancelText="No" onConfirm={this.restore} ><Popover content="Reset Password"><Icon type="reload" className="blueIcon" /></Popover></Popconfirm>
        let disableAction = this.state.user.isEnabled ?
            <Popconfirm title="Do you want to Disable this user?" okText="Yes" cancelText="No" onConfirm={this.disable} >
                <Popover content="Disable User">
                    <Icon type="eye-invisible" className="blueIcon" />
                </Popover>
            </Popconfirm> 
            :
            <Popconfirm title="Do you want to enable this user?" okText="Yes" cancelText="No" onConfirm={this.disable} >
                <Popover content="Enable User">
                    <Icon type="eye" className="blueIcon" />
                </Popover>
            </Popconfirm> 

        let ruolo = this.state.user.userRole.name ? this.state.user.userRole.name : null

        let date = this.state.user.created.slice(8, 10) + "/" + this.state.user.created.slice(5, 7) + "/" + this.state.user.created.slice(0, 4) + " (" + this.state.user.created.slice(11, 16) + ")"

        let initals = this.state.user.firstName.charAt(0) + this.state.user.lastName.charAt(0)

        return (
            <Card actions={[<div>{restoreAction}</div>, <div>{disableAction}</div>, <div>{deleteAction}</div>]}>
                <div className="fakeImageHr">{initals}</div>
                <h3 style={{ marginBottom: '0px' }}>{this.state.user.username} ({ruolo})</h3>

                <hr style={{ borderColor: "#000", marginTop: '20px' }} />

                <Container fluid={true}>
                    <Row className="cardDetailData">
                        <p style={{ width: '100%', textAlign: 'left' }}><b>Username:</b> {this.state.user.username}</p>
                        <br />
                        <p style={{ width: '100%', textAlign: 'left' }}><b>Name:</b> {this.state.user.firstName}</p>
                        <br />
                        <p style={{ width: '100%', textAlign: 'left' }}><b>Surname:</b> {this.state.user.lastName}</p>
                        <br />
                        <p style={{ width: '100%', textAlign: 'left' }}><b>Email:</b> {this.state.user.email}</p>
                        <br />
                        <p style={{ width: '100%', textAlign: 'left' }}><b>Status:</b> {enabled}</p>
                        <br />
                        <p style={{ width: '100%', textAlign: 'left' }}><b>Date of creation:</b> {date}</p>
                        <br />
                        
                    </Row>
                </Container>
            </Card >
        )
    }
}


// WEBPACK FOOTER //
// ./src/Users/UserCardDetail.js